<template>
  <div class="container">
    <div class="syslog-table">
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column type="index" label="No." width="70" align="center"></el-table-column>
        <el-table-column label="Operation Time" min-width="150">
          <template v-slot="{row}">
            <div v-if="row.createTime">{{ formatUtc(row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="File Size" prop="opType" min-width="150px">
          <template v-slot="{row}">
            <div v-if="row.fileSize">{{ bytesToSize(row.fileSize) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Content"
          prop="content"
          min-width="628px"
          :show-overflow-tooltip="false"
        >
          <template v-slot="{row}">
            <div class="query-content">
              <span
                v-if="!isEmpty(row.queryContent.merchantIds)"
              >Channel: {{ fetchChannelList(row.queryContent.merchantIds[0]) }}</span>
              <span
                v-if="row.queryContent.matchType"
              >Match Type: {{ macthType(row.queryContent.matchType) }}</span>
              <span
                v-if="row.queryContent.orderStartTime"
              >Bet Time: {{ formatUtc(row.queryContent.orderStartTime) }}-{{ formatUtc(row.queryContent.orderEndTime) }}</span>
              <span
                v-if="row.queryContent.settleStartTime"
              >Settle Time: {{ formatUtc(row.queryContent.settleStartTime) }}-{{ formatUtc(row.queryContent.settleEndTime) }}</span>
              <span
                v-if="!isEmpty(row.queryContent.matchIds)"
              >Match Id: {{ row.queryContent.matchIds[0] }}</span>
              <span
                v-if="!isEmpty(row.queryContent.userIds)"
              >User Id: {{ row.queryContent.userIds[0] }}</span>
              <span
                v-if="!isEmpty(row.queryContent.orderIds)"
              >Order Id: {{ row.queryContent.orderIds[0] }}</span>
              <span
                v-if="row.queryContent.isInplay !== null"
              >Match Status: {{ macthStatus(row.queryContent.isInplay) }}</span>
              <span
                v-if="row.queryContent.minStakeAmount || row.queryContent.maxStakeAmount"
              >Stake: {{ row.queryContent.minStakeAmount }}-{{ row.queryContent.maxStakeAmount }}</span>
              <span
                v-if="row.queryContent.companyWinLossMin || row.queryContent.companyWinLossMax"
              >Company P/L: {{ row.queryContent.companyWinLossMin }}-{{ row.queryContent.companyWinLossMax }}</span>
              <span
                v-if="row.queryContent.orderStatus"
              >Order Status: {{ feachName(1,row.queryContent.orderStatus[0]) }}</span>
              <span
                v-if="row.queryContent.seriesType !== null && !row.queryContent.cashout"
              >Bet Type: {{ feachName(2,row.queryContent.seriesType) }}</span>
              <span
                v-if="row.queryContent.seriesType !== null && row.queryContent.cashout"
              >Bet Type: {{ feachName(3,row.queryContent.seriesType) }}</span>
              <span
                v-if="row.queryContent.userLevel"
              >Level: {{ feachName(5,row.queryContent.userLevel) }}</span>
              <span
                v-if="row.queryContent.rollback !== null"
              >Roll Back: {{ rollBack(row.queryContent.rollback) }}</span>
              <span
                v-if="!isEmpty(row.queryContent.sportIds)"
              >Sport: {{ feachName(4,row.queryContent.sportIds[0]) }}</span>
              <span
                v-if="!isEmpty(row.queryContent.marketTypes)"
              >Market Type: {{ row.queryContent.marketTypes[0] }}</span>
              <span
                v-if="!isEmpty(row.queryContent.tournamentIds)"
              >Tournament: {{ row.queryContent.tournamentIds[0] }}</span>
              <span
                v-if="!isEmpty(row.queryContent.period)"
              >Period: {{ row.queryContent.period[0] }}</span>
              <span
                v-if="!isEmpty(row.queryContent.marketIds)"
              >Line: {{ row.queryContent.marketIds[0] }}</span>
              <span
                v-if="!isEmpty(row.queryContent.options)"
              >Option: {{ row.queryContent.options[0] }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Operator"
          prop="operateName"
          min-width="180px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="Status" prop="progressStatus" min-width="150px">
          <template v-slot="{row}">
            <div>{{ feachStatus(row.progressStatus) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Operation" prop="opType" min-width="250px">
          <template v-slot="{row}">
            <el-button
              class="table-inner-btn"
              v-if="row.fileUrl"
              @click="Download(row.fileUrl)"
            >Download</el-button>
            <el-button
              class="table-inner-btn"
              v-if="row.progressStatus == 1 || row.progressStatus == 2"
              @click="handleChange(1,row)"
            >Cancel</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <dia ref="dialogDom" class="label-dialog">
      <!-- 删除3 -->
      <div class="dialog-footer table-search-part" v-if="num == 1">
        <el-button class="search-btn" @click="Cancel()">Confirm</el-button>
        <el-button class="clear-btn" @click="Close()">Cancel</el-button>
      </div>
    </dia>
    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Empty from "@/components/empty/index";
import dia from "@/components/dialog/index";
import { getOrderList, orderCancel } from "@/api/downOrder";
import { getMerchat, getLevelList } from "@/api/member";
import { getTcsSportList } from "@/api/memberDetail";
export default {
  name: "LogList",
  data() {
    return {
      list: [],
      num: 0,
      merchatList: [],
      sportList: [],
      levelList: [],
      total: 0,
      loading: false,
      queryData: {
        current: 1,
        size: 50
      },
      statusList: [
        {
          id: 1,
          label: "WAITING"
        },
        {
          id: 2,
          label: "PROCESSING"
        },
        {
          id: 3,
          label: "SUCCESS"
        },
        {
          id: 4,
          label: "FAIL"
        },
        {
          id: 5,
          label: "CANCEL"
        }
      ],
      orderStatus: [
        { id: 0, name: "Open Bets" },
        { id: 1, name: "Open Bets" },
        { id: 2, name: "Rejected" },
        { id: 3, name: "Canceled" },
        { id: 5, name: "Settled" }
      ],
      betType: [
        { id: 0, name: "Single" },
        { id: 1, name: "Parlay" }
      ],
      cashoutBetType: [
        { id: 0, name: "CashOut Single" },
        { id: 1, name: "CashOut Parlay" }
      ],
      labelId: "",
      title: "",
      timer: null,
      tableHeight: window.innerHeight
    };
  },
  methods: {
    orderDate([startTime, endTime]) {
      this.queryData.startTime = startTime;
      this.queryData.endTime = endTime;
    },
    async getList(val) {
      this.loading = val;
      try {
        const res = await getOrderList(this.queryData);
        const data = res.data || {};
        this.list = data.records || [];
        this.total = data.total;
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getLevelList() {
      const res = await getLevelList({});
      let data = res.data || [];
      this.levelList = data;
    },
    async getSportList() {
      try {
        const res = await getTcsSportList({ matchType: '' });
        const data = res.data || [];
        this.sportList = data;
      } catch (error) {
        this.sportList = [];
      }
    },
    // merchant下拉框
    async getMerchatList() {
      const res = await getMerchat({});
      let data = res.data || {};
      this.merchatList = data;
    },
    getArray(data) {
      return Object.keys(data).map(el => {
        return {
          id: el,
          name: data[el]
        };
      });
    },
    macthStatus(val) {
      if (val == true) {
        return "Live";
      } else {
        return "Pre-match";
      }
    },
    rollBack(val) {
      if (val == true) {
        return "Yes";
      } else {
        return "No";
      }
    },
    macthType(val) {
      const n = Number(val);
      switch (n) {
        case 2:
          return 'Sports Match';
        case 1:
          return 'Sports Outright';
        case 3:
          return 'E-Sports Match';
        case 5:
          return 'E-Sports Outright';
        case 4:
          return 'Virtual Match';
        default:
          return '-';
      }
    },
    fetchChannelList(arr) {
      let nameStr = "";
      let res = this.merchatList.map(item => {
        if (item.id == arr) {
          nameStr = item.name;
        }
      });
      return nameStr;
    },
    feachName(num, val) {
      let status = "";
      if (num == 1) {
        this.orderStatus.map(item => {
          if (item.id == val) {
            status = item.name;
          }
        });
      }
      if (num == 2) {
        this.betType.map(item => {
          if (item.id == val) {
            status = item.name;
          }
        });
      }
      if (num == 3) {
        this.cashoutBetType.map(item => {
          if (item.id == val) {
            status = item.name;
          }
        });
      }
      if (num == 4) {
        this.sportList.map(item => {
          if (Number(item.code) == val) {
            status = item.value;
          }
        });
      }
      if (num == 5) {
        this.levelList.map(item => {
          if (Number(item.id) == val) {
            status = item.name;
          }
        });
      }
      return status;
    },
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) {
        return "0 Bytes";
      } else {
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
      }
    },
    feachStatus(val) {
      let status = "";
      this.statusList.map(item => {
        if (item.id == val) {
          status = item.label;
        }
      });
      return status;
    },
    handleChange(num, data) {
      this.num = num;
      if (num == 1) {
        // 添加
        this.title = "Cancel Progress?";
        this.labelId = data.id;
      }
      this.$refs["dialogDom"].isShowDia(this.title, true, "323px");
    },
    // 修改
    async Download(val) {
      window.location.href = val;
    },
    // 删除
    async Cancel() {
      const res = await orderCancel({ id: this.labelId });
      if (res.code == 0) {
        this.$message({ message: "delete success", type: "success" });
        this.getList(true);
        this.Close();
      }
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "323px");
    },
    isEmpty(value) {
      if (value === null) {
        return true;
      }
      if (Array.isArray(value)) {
        return !value.length;
      }
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList(true);
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList(true);
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    }
  },
  components: {
    Empty,
    dia
  },
  mounted() {
    this.getLevelList();
    this.getSportList();
    this.getMerchatList();
    this.timer = setInterval(() => {
      this.getList(false);
    }, 3000);
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style lang="scss" scoped>
.syslog-table {
  margin-top: 15px;
}
.module-input {
  margin: 0 20px 0 0 !important;
}
.btn-wrapper {
  margin: 15px 0 0 10px;
}
.query-content {
  span {
    margin-right: 10px;
    display: inline-block;
  }
}
</style>
